import { useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ILocation } from "providers/venue/types"
import { useAppUI } from "providers/ui"
import { pushDataLayer } from "utils/googletagmanager"
import { GTM_VIEW_SERVICE } from "constant"

export const useServiceLocation = () => {
  const navigate = useNavigate()
  const { isKioskMode } = useAppUI()
  const [externalUrl, setExternalUrl] = useState<string | null>(null)

  const handleClickLocation = useCallback(
    (location: ILocation) => {
      const url = location?.url
      const linkType = location.type

      pushDataLayer({
        event: GTM_VIEW_SERVICE,
        service_id: location?.id,
        service_title: location?.label?.en,
      })

      if (linkType !== "custom" && url) {
        navigate(url)
        return
      }
      if (isKioskMode) {
        setExternalUrl(url)
      } else {
        window.open(url)
      }
    },
    [navigate, isKioskMode]
  )

  const handleCloseModal = useCallback(() => {
    setExternalUrl(null)
  }, [])

  return {
    externalUrl,
    handleClickLocation,
    handleCloseModal,
  }
}
